angular
  .module('company')

  .directive('headquarterPreview', function() {
    return {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        headquarter: '=ngModel',
        showActive: '@',
        showLegal: '@'
      },
      templateUrl: 'custom/company/views/partials/headquarterPreview.html'
    };
  });
